


































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data";
import { ContentService } from "@/service/content.service";
import { PreviouslyAppliedHSContent } from "@/models/content/previously-applied-hs";
import { QualifierRule, matchQualifiers } from "@/models/rules";

@Component({
  components: {
    FooterButton,
  },
})
export default class PreviouslyAppliedHS extends Mixins(CommonMixin) {
  Selection: boolean | null = null;
  content: PreviouslyAppliedHSContent = {} as PreviouslyAppliedHSContent;
  PercentDone = 85;
  appData = {} as AppData;
  textDirection = "ltr";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getPreviouslyAppliedHSContent();
      this.textDirection = contentService.TextDirection();

      this.appData = this.getAppData();

      if (this.appData != null) {
        if (this.appData.headStartUnableToFind != null) {
          this.Selection = this.appData.headStartUnableToFind;
        }
        await this.putWorkflowStep( this.appData.workflowId, "PreviouslyAppliedHS") 
      }
    } catch (error) {
      this.showError(error as any);
    }
  }

  disableNext(): boolean {
    return this.Selection == null;
  }

  public handleNextPageEvent(): void {
    this.appData.headStartUnableToFind = this.Selection;
    this.saveAppData(this.appData);

    if (this.allChildren4AndOver(this.appData)) {
      this.handleAllFourAndOver();
    } else {
      this.handleBothUnderAndOverFour();
    }
  }

  handleBothUnderAndOverFour(): void {
    const rules: QualifierRule[] = [
       { index: [true, County.Wayne, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [true, County.Macomb, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [true, County.Oakland, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [true, County.Washtenaw, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [false, County.Wayne, undefined], path: 'MatchHeadstartReferral' }
       ,{ index: [false, County.Macomb, undefined], path: 'MatchHeadstartAndHSGSRPLikelyReferral' }
       ,{ index: [false, County.Oakland, undefined], path: 'MatchHeadstartAndHSGSRPLikelyReferral' }
       ,{ index: [false, County.Washtenaw, undefined], path: 'MatchHeadstartAndHSGSRPLikelyReferral' }
    ]

    const unableToFind = this.appData.headStartUnableToFind === true
    const rule = matchQualifiers(rules, unableToFind, this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleAllFourAndOver(): void {
    const rules: QualifierRule[] = [
        { index: [false, County.Wayne, undefined], path: 'MatchHeadstartReferral' }
       ,{ index: [false, County.Macomb, undefined], path: 'MatchHSGSRPLikelyReferral' }
       ,{ index: [false, County.Oakland, undefined], path: 'MatchHSGSRPLikelyReferral' }
       ,{ index: [false, County.Washtenaw, undefined], path: 'MatchHSGSRPLikelyReferral' }
       ,{ index: [true, County.Wayne, undefined], path: 'MatchGSRPReferral' }
       ,{ index: [true, County.Macomb, undefined], path: 'MatchGSRPReferral' }
       ,{ index: [true, County.Oakland, undefined], path: 'MatchGSRPReferral' }
       ,{ index: [true, County.Washtenaw, undefined], path: 'MatchGSRPReferral' }
    ]

    const unableToFind = this.appData.headStartUnableToFind === true

    const rule = matchQualifiers(rules, unableToFind, this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }


}
